var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-card-list u-bg-color-brand-two-lighten-100" },
    [
      _c(
        "div",
        { staticClass: "grid-container" },
        [
          _c("div", { staticClass: "c-card-list__intro" }, [
            _c(
              "div",
              {
                staticClass: "filter-holder",
                class: [_vm.isSearchOpen ? "filter-holder--stack-mob" : ""]
              },
              [
                (_vm.categoryTags && _vm.categoryTags.length) ||
                (_vm.topicTags && _vm.topicTags.length)
                  ? _c("div", { staticClass: "c-list-filter" }, [
                      _c(
                        "div",
                        { staticClass: "c-list-filter__button" },
                        [
                          _c("filter-button", {
                            attrs: { name: "Filter" },
                            on: { clicked: _vm.toggleMobileFilter }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "c-list-filter__options",
                          class: [
                            _vm.isMobileFilterOpen
                              ? "c-list-filter__options--active"
                              : ""
                          ]
                        },
                        [
                          _vm.categoryTags && _vm.categoryTags.length
                            ? _c(
                                "div",
                                { staticClass: "c-list-filter__item" },
                                [
                                  _c("filter-dropdown", {
                                    attrs: {
                                      label: _vm.categoryTagsTitle,
                                      options: _vm.categoryTags
                                    },
                                    on: { changed: _vm.getData },
                                    model: {
                                      value: _vm.selectedCategoryTag,
                                      callback: function($$v) {
                                        _vm.selectedCategoryTag = $$v
                                      },
                                      expression: "selectedCategoryTag"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.topicTags && _vm.topicTags.length
                            ? _c(
                                "div",
                                { staticClass: "c-list-filter__item" },
                                [
                                  _c("filter-dropdown", {
                                    attrs: {
                                      label: _vm.topicTagsTitle,
                                      options: _vm.topicTags
                                    },
                                    on: { changed: _vm.getData },
                                    model: {
                                      value: _vm.selectedTopicTag,
                                      callback: function($$v) {
                                        _vm.selectedTopicTag = $$v
                                      },
                                      expression: "selectedTopicTag"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.textSearch == "true"
                  ? _c("filter-search", {
                      attrs: { label: "Search" },
                      on: {
                        toggleSearchOpen: _vm.toggleSearchOpen,
                        changed: _vm.getData
                      },
                      model: {
                        value: _vm.searchTerm,
                        callback: function($$v) {
                          _vm.searchTerm = $$v
                        },
                        expression: "searchTerm"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "fade", appear: "", mode: "out-in" } },
            [
              _vm.hasResultsLoaded
                ? _c("div", { key: "results" }, [
                    _vm.results.length
                      ? _c(
                          "div",
                          { staticClass: "c-card-list__grid" },
                          _vm._l(_vm.results, function(item) {
                            return _c("card", {
                              key: item.id,
                              attrs: { item: item }
                            })
                          }),
                          1
                        )
                      : _c("div", { staticClass: "c-card-list__message" }, [
                          _vm._v(
                            "\n          Sorry, no results found.\n        "
                          )
                        ])
                  ])
                : _vm.hasError
                  ? _c(
                      "div",
                      { key: "error", staticClass: "c-card-list__message" },
                      [_vm._v("\n        Sorry, something went wrong.\n      ")]
                    )
                  : _c(
                      "div",
                      { key: "loading", staticClass: "c-card-list__message" },
                      [
                        _c("div", { staticClass: "lds-facebook" }, [
                          _c("div"),
                          _c("div"),
                          _c("div")
                        ])
                      ]
                    )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c4092dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c4092dc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/card-list/CardList.vue
// module id = 651
// module chunks = 0